function formatUnitName (unit) {
    const yearString = unit.year ? `(${unit.year})` : null;
    const modelString = `${unit.brand ?? ""} ${unit.model ?? ""}`.trim();

    if (modelString.length > 0) {
        const baseString = `${unit.name} | ${modelString}`;

        if (yearString != null) {
            return `${baseString} ${yearString}`;
        }

        return baseString;
    }

    return unit.name;
}

export { formatUnitName };
